<template>
  <jackpot-container />
</template>

<script>
import { DrawerDialog } from '../components/core/DrawerDialog'
import { JackpotContainer, } from '@/modules/jackpots'

export default {
  components: {
    DrawerDialog,
    JackpotContainer,
  },
}
</script>
